import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ProjectSettingsServicedeskProactiveServiceManagementAppExtraProps } from './projectSettingsServicedeskProactiveServiceManagement.entrypoint.types.tsx';

type ProjectSettingsServicedeskProactiveServiceManagementAppEntryPointProps = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{},
	ProjectSettingsServicedeskProactiveServiceManagementAppExtraProps
>;

export const projectSettingsServicedeskProactiveServiceManagementAppEntryPoint: EntryPoint<
	ProjectSettingsServicedeskProactiveServiceManagementAppEntryPointProps,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectSettingsServicedeskProactiveServiceManagementAppEntryPointProps>(
		/* webpackChunkName: "async-project-settings-proactive-service-management", jiraSpaEntry: "async-project-settings-proactive-service-management" */
		'./ProjectSettingsServicedeskProactiveServiceManagementApp.tsx',
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		return {
			extraProps: {
				projectKey: String(match.params.projectKey ?? ''),
			},
		};
	},
});
